import { addLocaleData } from 'react-intl';
import fr from 'react-intl/locale-data/fr';

import { setTranslations as setNavTranslations } from '@99designs/common/apps/global-nav/locale-data';
import navFr from '@99designs/common/apps/global-nav/locale-data/fr';

setNavTranslations(navFr);
addLocaleData(fr);



// WEBPACK FOOTER //
// ./src/web/js/locale-data/fr.js